import { Injectable } from "@angular/core";
import { AirbrakeService } from "../airbrake/airbrake.service";

@Injectable()
export class RoundTimeService {
  constructor(private airbrakeService: AirbrakeService) {}

  // Rounds timestamps depending on provided `dur` (simply nullifies hours,
  // minutes or seconds accordingly).
  //
  // Returns a new rounded timestamp.
  public timestampFor(timestamp: string, dur: string) {
    const date = new Date(timestamp);

    switch (dur) {
      case "90d/1d":
        date.setUTCHours(0, 0, 0, 0);
        break;
      case "90h/1h":
        date.setUTCMinutes(0, 0, 0);
        break;
      case "90m/1m":
        date.setUTCSeconds(0, 0);
        break;
      default:
        this.airbrakeService.notifier.notify({
          error: "Invalid duration in roundTime",
          params: { duration: dur },
        });
        break;
    }

    return date.toISOString();
  }
}
